import { openDB } from "idb";

const DATABASE_NAME = "valuesearch-db";
const DATABASE_VERSION = 1;

export const dbPromise = openDB(DATABASE_NAME, DATABASE_VERSION, {
  upgrade(db) {
    if (!db.objectStoreNames.contains("screeningTree")) {
      db.createObjectStore("screeningTree", {
        keyPath: "id"
      });
    }
  }
});
